import { Legend as HuiLegend } from '@headlessui/react';
import { FC } from 'react';
import Markdown from 'react-markdown';
import { cx } from '@/utils/cx';

export type SubsectionHeadingGroupProps = {
  className?: string;
  title: string;
  description?: string;
};

export const Legend: FC<SubsectionHeadingGroupProps> = ({
  className,
  title,
  description,
}) => (
  <HuiLegend className={cx('mb-3 flex flex-col', className)}>
    <span className="min-h-6 text-sm/6 font-medium">
      <Markdown>{title}</Markdown>
    </span>
    {description && (
      <span className="min-h-5 text-sm font-normal text-gray-500">
        <Markdown>{description}</Markdown>
      </span>
    )}
  </HuiLegend>
);
